"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgLike = function SvgLike(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.836 2.424c-1.108-.124-2.089.588-2.455 1.612L7.738 8.637c.004.05.007.101.008.151a282.078 282.078 0 0 1 .003 11.852h.043l.032.005.145.022a79.458 79.458 0 0 0 2.633.34c1.758.197 4.21.419 6.979.519 1.871.067 3.593-1.018 4.113-2.846.521-1.83 1.093-4.552 1.301-8.124a2.835 2.835 0 0 0-2.982-2.996 91.577 91.577 0 0 0-4.935.373l-.137-2.76c-.057-1.128-.627-2.27-1.822-2.54a11.908 11.908 0 0 0-1.283-.21ZM3.818 21.58a6.899 6.899 0 0 1-1.524-.166c-.779-.177-1.21-.894-1.23-1.636C1.036 18.728 1 16.967 1 14.77c0-2.198.036-3.959.064-5.01.02-.741.451-1.458 1.23-1.634a6.896 6.896 0 0 1 1.524-.167c.603 0 1.117.074 1.525.167.778.176 1.209.893 1.229 1.635.029 1.05.064 2.811.064 5.01 0 2.197-.035 3.958-.064 5.008-.02.742-.451 1.459-1.23 1.636a6.899 6.899 0 0 1-1.524.166Z",
    fill: "#000"
  }));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgLike);
var _default = exports["default"] = Memo;